// extracted by mini-css-extract-plugin
export default {"pdfViewer":"RefereeReport_pdfViewer__BUj-R"};